/**
 * LİSTE SINIRI UYARISI — "kart bir sayı diyor, liste başka gösteriyor"un ilacı.
 *
 * ── NİÇİN VAR ──────────────────────────────────────────────────────────────
 * Üretim, SSH ve Stok Siparişi ekranları kaydı `limit(200/300)` ile okuyor ama
 * statü kartı GERÇEK sayıyı gösteriyor. Canlı ölçüm (2026-08-16):
 *   · Tamamlanan Üretim → kart 4.470, liste 200
 *   · Tamamlandı (sipariş) → 13.974
 * Ekran hiçbir şey söylemiyordu: kullanıcı kartta 4.470 görüp listede 200 kayıt
 * sayınca "veriler bağlı değil" sonucuna varıyordu. Sorgu geçerliydi, sayı
 * doğruydu — eksik olan CÜMLEYDİ.
 *
 * ★ SESSİZ KESME YOK: liste sınıra dayandıysa ekran bunu SÖYLER ve kaç kaydın
 * görünmediğini yazar. Sıralama `createdAt desc` olduğu için görünmeyenler EN
 * ESKİ kayıtlardır; kullanıcı neyi kaçırdığını bilmeli.
 */
export function ListLimitNotice({
  shown,
  total,
  limit,
  hint,
}: {
  /** Ekranda fiilen listelenen kayıt sayısı. */
  shown: number;
  /** Statü kartındaki gerçek toplam. Sayılamadıysa `undefined`. */
  total: number | undefined;
  /** Sorgudaki üst sınır. */
  limit: number;
  /** Ne yapılabileceğini söyleyen ek cümle (ekrana özel). */
  hint?: string;
}) {
  // Sınıra DAYANMADIYSA hiçbir şey yazma: her listenin altında duran bir not
  // gürültüdür ve gerçek uyarıyı görünmez kılar.
  if (shown < limit) return null;

  const hidden = typeof total === "number" ? total - shown : null;

  return (
    <p
      role="status"
      className="mt-3 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900"
    >
      <strong>Liste bu sayfada {shown} kayıtla sınırlı.</strong>{" "}
      {hidden !== null && hidden > 0 ? (
        <>
          Bu statüde toplam <strong>{total}</strong> kayıt var; <strong>{hidden}</strong> tanesi
          burada görünmüyor (en eskiler).
        </>
      ) : (
        <>Bu statüde daha fazla kayıt olabilir.</>
      )}{" "}
      {hint ?? "Aradığınız kayıt görünmüyorsa üstteki arama kutusunu kullanın."}
    </p>
  );
}
